import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import BienVenido from "./BienVenido";
import Hectareas from "./Hectareas";
import Cultivos from "./Cultivos";
import Usuarios from "./UsuariosActivos";
import TipologiaUsuarios from "./UsuariosConfirmados";


interface IProps {
}

interface Istate {
}


class Dashboard extends React.Component<IProps, Istate> {

    state:Istate = {
    }


    render() {

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: "center",
                    justifyContent: "center",
                    width: '100%',
                    height: '100%',
                    backgroundColor: "#ECECEC"
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        width: 'calc(100% - 80px)',
                        height: 'calc(100% - 80px)',
                        backgroundColor: "transparent"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            width: '100%',
                            height: 'calc(50% - 10px)',
                            backgroundColor: "transparent"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: 'calc((24% - (40px)/3))',
                                height: '100%',
                                backgroundColor: "transparent"
                            }}
                        >
                            <BienVenido/>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: 'calc((38% - (40px)/3))',
                                height: '100%',
                                backgroundColor: "transparent"
                            }}
                        >
                            <Hectareas/>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: 'calc((38% - (40px)/3))',
                                height: '100%',
                                backgroundColor: "transparent"
                            }}
                        >
                            <Cultivos/>
                        </div>

                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            width: '100%',
                            height: 'calc(50% - 10px)',
                            backgroundColor: "transparent"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: 'calc(100% - (38% - (40px)/3) - 20px)',
                                height: '100%',
                                backgroundColor: "transparent"
                            }}
                        >
                            <Usuarios/>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: 'calc((38% - (40px)/3))',
                                height: '100%',
                                backgroundColor: "transparent"
                            }}
                        >
                            <TipologiaUsuarios/>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
